import { ThemeStyles } from '@apia/theme';

const calendar: () => ThemeStyles = () => ({
  '.react-calendar': {
    backgroundColor: 'palette.background.paper',
    padding: '0',
    margin: '0',
    fontFamily: 'inherit',
    maxWidth: '400px',
    minWidth: '200px',
  },
  '.react-calendar abbr': { textDecoration: 'none', userSelect: 'none' },
  '.react-calendar__tile': {
    variant: 'buttons.paper',
    px: 0,
    py: 0,
  },
  '.react-calendar__month-view__weekdays': {
    margin: '8px 0 8px 0',
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  '.react-calendar__month-view__days': {
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  '.react-calendar__navigation': { marginBottom: '4px', display: 'flex' },
  '.react-calendar__navigation__label': {
    variant: 'buttons.paper',
    p: '3px',
  },
  '.react-calendar__navigation__label__labelText': {
    fontFamily: 'inherit',
    fontSize: '16px',
  },
  '.react-calendar__month-view__days__day': {
    variant: 'buttons.calendarDay',
  },
  '.react-calendar__navigation__arrow': {
    variant: 'buttons.paper-sm',
    textAlign: 'center',
    flexShrink: 0,
  },
});

export default calendar;
